class CustomAmountControl {
  static states = {
    inactive: "border-inherit",
    active: "border-(--defaults-color-primary-alt)!",
    checked: "border-(--defaults-color-primary)!",
  };

  constructor(wrapperEl) {
    this.wrapperEl = wrapperEl;
    this.inputEl = this.wrapperEl.querySelector("input");
    this.prefixEl = this.wrapperEl.querySelector("label");
    this.active = false;

    this.inputEl.addEventListener("input", this.paint.bind(this));
    this.inputEl.addEventListener("focus", this.focus.bind(this));
    this.inputEl.addEventListener("blur", this.blur.bind(this));

    this.paint();
  }

  set value(value) {
    this.inputEl.value = value;
    this.paint();
  }

  get value() {
    return this.inputEl.value;
  }

  set disabled(value) {
    this.inputEl.disabled = value;
    this.paint();
  }

  get disabled() {
    return this.inputEl.disabled;
  }

  set prefix(value) {
    this.prefixEl.innerText = value;
  }

  focus() {
    this.active = true;
    this.paint();
  }

  blur() {
    this.active = false;
    this.paint();
  }

  get checked() {
    return this.inputEl.value !== "";
  }

  paint() {
    this.wrapperEl.classList.remove(
      ...Object.values(CustomAmountControl.states),
    );

    if (this.disabled) {
      this.wrapperEl.classList.add(CustomAmountControl.states.inactive);
    } else if (this.checked) {
      this.wrapperEl.classList.add(CustomAmountControl.states.checked);
    } else if (this.active) {
      this.wrapperEl.classList.add(CustomAmountControl.states.active);
    } else {
      this.wrapperEl.classList.add(CustomAmountControl.states.inactive);
    }
  }
}

export default CustomAmountControl;
